import { atom, useAtom } from 'jotai';
import { atomWithImmer } from 'jotai/immer';
import { useUpdateAtom, useAtomValue, RESET } from 'jotai/utils';
export var defaulState = {
  payLoading: false,
  cancelLoading: false,
  changeCardModalVisible: false,
  weiXinPayModalVisible: false,
  huifuWeiXinModalVisible: false,
  creditCardPayModalVisible: false,
  notCanPayUpgradeSubBill: false,
  isBillIdByCreateSub: false,
  radioPayMethod: ''
};
export var stateAtom = atomWithImmer(defaulState);
export var proxyStateAtom = atom(function (get) {
  return get(stateAtom);
}, function (get, set, action) {
  set(stateAtom, action === RESET ? defaulState : action);
});

// update-only atom
export function useStateAtomUpdate() {
  return useUpdateAtom(stateAtom);
}

// read-write atom
export function useStateAtom() {
  return useAtom(stateAtom);
}

// read-only atom
export function useStateAtomValues() {
  return useAtomValue(stateAtom);
}